import { NotificationsNoneOutlined, Settings } from "@mui/icons-material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ExpandCircleDownOutlined from '@mui/icons-material/ExpandCircleDownOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import LoanEligibleToggle from './LoanEligibleToggle';
import NotificationBell from "./NotificationBell";
import {
  Avatar,
  Box,
  Button,
  Container,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import Badge from "@mui/material/Badge";
import showPremiumAlert, { getCurrentUserId, getCustomerInfoFromLocalStorage } from "../../../utils/utils";
import React, { useState, useRef, useEffect } from "react";
import { refreshWatchlist } from "../../../Redux/watchlistSlice";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { logout } from "../../../Redux/authSlice";
import { getUserFromLocalStorage } from "../../../utils/utils";
import { log } from "console";
import Axios from "../../../config/axios";
import { UrlConstant } from "../../../commom/UrlConstant";
import { KYC_STATUS, KycStatusValue } from "../SharedComponent/OnboardingStatusBar";
import { usePriceFormatter } from "../../../hooks";
import { formatPercentage } from "../../../utils/formatting";
import { useAppDispatch } from "../../../Redux/hooks";
interface SearchResult {
  stock_pic: string;
  name: string
  symbol: string;
  price: number;
  type: string;
  isAddedtoWatchlist: Boolean;
}


interface KycStatusResponse {
  status: KycStatusValue;
}


function Header(props) {
  const customerInfo = getCustomerInfoFromLocalStorage();
  const isPremium = customerInfo?.entitlements?.active?.Premium?.isActive;
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigation = useNavigate();
  const navigate = useNavigate();
  const [user, setUser] = useState<any>({});
  const [fullName, setFullName] = React.useState<string>("");
  const [search, setsearch] = React.useState<string>("");
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [isVisible, setIsVisible] = useState(true); // Control visibility
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [isWatchlist, setIsWatchlist] = React.useState<any>(false);
  const [isTradingAcExist, setIsTradingAcExist] = React.useState(false);
  const [isActivebtn, setIsActivebtn] = useState(false);
  const navScrollRef = useRef<HTMLDivElement | null>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);
  const [moreAnchorEl, setMoreAnchorEl] = useState<null | HTMLElement>(null);
  const [kycStatus, setKycStatus] = useState<KycStatusValue | null>(null);
  const isMoreOpen = Boolean(moreAnchorEl);
  const formatter = usePriceFormatter();
  // Handle click outside


  useEffect(() => {
    const hasTradingAccount =
      user.tradingblock_status?.toLocaleUpperCase() === "COMPLETE" &&
      user.tradingblock_application_id !== null;

    if (hasTradingAccount || user?.isCryptoOnboardCompleted) {
      setIsTradingAcExist(true);
    } else {
      setIsTradingAcExist(false);
    }
  }, [user]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && dropdownRef.current.contains) {

        if (!dropdownRef.current.contains(event.target)) {
          setIsVisible(false); // Hide the dropdown
          setsearch('')

        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const CreateWatchList = async (stock) => {
    let symbol = stock.symbol;
    let type = stock.type || 'stock';
    if (type === 'crypto') {
      symbol = stock.cmc_id;
    }
    const payLoad = {
      userId: getCurrentUserId(),
      symbol,
      type,
    };
    const URL = stock.isAddedToWatchList
      ? UrlConstant.WachList.RemoveWatchList
      : UrlConstant.WachList.CreateWatchList;
    try {
      let response;
      if (stock.isAddedToWatchList) {
        response = await Axios.delete(URL.replace('{0}', symbol));
        if (response.data.result) {
          setIsWatchlist(false);
          // notify other parts of the app to refresh watchlist
          try { dispatch(refreshWatchlist()); } catch (e) { /* ignore */ }
        }
      } else {
        response = await Axios.post(URL, payLoad);
        if (response.data.result) {
          setIsWatchlist(true);
          // notify other parts of the app to refresh watchlist
          try { dispatch(refreshWatchlist()); } catch (e) { /* ignore */ }
        }
      }
      const resData = response.data;
    } catch (error) {
      console.error('ERRR : ', error);
    } finally {
      // Add any cleanup or final actions here
    }
  };

  const handleToggleWatchList = (stock) => {
    if (stock) {
      CreateWatchList(stock);
      setSearchResults(prevResults =>
        prevResults.map(item => {
          const match = stock.type === 'crypto' ? item.cmc_id === stock.cmc_id : item.symbol === stock.symbol;
          return match
            ? { ...item, isAddedToWatchList: !item.isAddedToWatchList }
            : item;
        })
      );
    } else {
      console.error('Stock object is undefined or missing symbol property.');
    }
  };

  const handleSearch = async (query: string) => {
    if (query) {
      try {
        const response = await Axios.get(UrlConstant.Header.searchStock.replace("{0}", query));
        setSearchResults(response.data.data);
        setIsVisible(true)
      } catch (error) {
        console.error('Error fetching search results:', error);
      }
    } else {
      setSearchResults([]);
    }
  };

  const normalizeStockData = (item) => {
    if (item.type === "crypto") {
      return {
        id: item._id,
        type: "crypto",
        symbol: item.symbol,
        displayName: item.name,
        logo: item.logo,
        stockPrice: item.quote?.USD?.price ?? 0,
        change: item.quote?.USD?.percent_change_24h ?? 0, // 24h change
        change_percent: item.quote?.USD?.percent_change_24h ?? 0,
        isAddedToWatchList: item.isAddedToWatchList ?? false,
        cmc_id: item.cmc_id,
      };
    } else {
      return {
        id: item._id,
        type: "stock",
        symbol: item.symbol,
        displayName: item.displayName,
        logo: item.branding?.icon_url ?? item.branding?.logo_url,
        stockPrice: item.stockPrice ?? item.regularMarketPrice ?? 0,
        change: item.change ?? 0,
        change_percent: item.change_percent ?? 0,
        isAddedToWatchList: item.isAddedToWatchList ?? false,
      };
    }
  };

  React.useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      handleSearch(search);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [search]);


  React.useEffect(() => {
    setUser(getUserFromLocalStorage());
    const handleUserUpdated = () => {
      const latest = getUserFromLocalStorage();
      setUser(latest || {});
    };
    window.addEventListener('user-updated', handleUserUpdated as any);
    return () => {
      window.removeEventListener('user-updated', handleUserUpdated as any);
    };
    // setFullName('Ravi Patel')
  }, []);

  React.useEffect(() => {
    setFullName(`${user?.firstName} ${user?.lastName}`);
  }, [user]);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const logOut = () => {
    dispatch(logout());
    navigation("/login");
  };
  const handleMoreOpen = (event: React.MouseEvent<HTMLElement>) => setMoreAnchorEl(event.currentTarget);
  const handleMoreClose = () => setMoreAnchorEl(null);

  const updateScrollButtons = () => {
    const el = navScrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    setHasOverflow(el.scrollWidth > el.clientWidth + 1);
  };

  useEffect(() => {
    const el = navScrollRef.current;
    updateScrollButtons();
    if (el) {
      el.addEventListener('scroll', updateScrollButtons);
    }
    window.addEventListener('resize', updateScrollButtons);
    return () => {
      if (el) el.removeEventListener('scroll', updateScrollButtons);
      window.removeEventListener('resize', updateScrollButtons);
    };
  }, []);
  // Smoothly scroll to edge on hover
  const smoothScrollToEdge = (direction: 'left' | 'right') => {
    const el = navScrollRef.current;
    if (!el) return;
    const target = direction === 'right'
      ? Math.max(0, el.scrollWidth - el.clientWidth)
      : 0;
    el.scrollTo({ left: target, behavior: 'smooth' });
  };
  const boosterLoanPath = (user?.boosterLoanOptIn === true || !!user?.boosterloan_id) ? '/boosterloan' : '/boosterlending';

  const isTradingAccountComplete = kycStatus === KYC_STATUS.COMPLETED;

  const fetchKycStatus = async () => {
    try {
      const response = await Axios.get(UrlConstant.Sumsub.CheckAccountStatus);

      if (response.data?.success) {
        const { status } = response.data.data as KycStatusResponse;

        setKycStatus(status);
      }
    } catch (error) {
      console.error("KYC Status Check Error:", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchKycStatus();
  }, []);

  return (
    <>
      <Container
        maxWidth={false}
        sx={{
          height: "70px",
          margin: "0",

          // padding:'0px !important',
          // paddingTop:'20px',
          // paddingBottom:'20px',
          // paddingRight: "300px !important",
          // paddingLeft: "300px !important",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        className="bg-color"
      >
        <Link to="/dashboard">
          <svg
            width="126"
            height="24"
            viewBox="0 0 126 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.29097 19.9558C6.2701 20.1033 6.25967 20.2521 6.25977 20.401C6.25977 22.3891 8.09853 24 10.3671 24C12.6356 24 14.4746 22.3885 14.4746 20.401C14.4746 20.2521 14.4642 20.1033 14.4434 19.9558C14.0389 21.5902 13.0024 22.7531 11.7874 22.7531C11.27 22.7531 10.7849 22.542 10.3671 22.1737C9.94949 22.542 9.46441 22.7531 8.94699 22.7531C7.73203 22.7531 6.69549 21.5902 6.29097 19.9558Z"
              fill="url(#paint0_linear_442_396)"
            />
            <path
              d="M18.0214 5.31398C18.0028 5.90141 17.9171 6.48489 17.7661 7.05339C17.7193 7.22867 17.7054 7.14579 17.7094 7.08139C17.7533 6.36849 17.5485 5.69675 17.2237 5.13226C17.115 5.46088 16.9573 5.77165 16.7557 6.05432C16.7767 5.64466 16.7223 5.23463 16.5951 4.84413C16.6156 4.92815 16.6243 5.01454 16.6209 5.1009C16.605 5.58587 16.2181 5.96556 15.7569 5.94848C15.2956 5.9314 14.9342 5.52455 14.951 5.03957C14.9606 4.74893 15.0928 4.47956 15.3158 4.34376C16.1639 3.83254 16.9318 3.20184 17.5953 2.47163C17.9082 3.38605 18.0523 4.34847 18.0209 5.31314L18.0214 5.31398ZM5.78351 5.03818C5.79968 5.52315 5.43885 5.93028 4.97788 5.94708C4.51691 5.96388 4.13027 5.58531 4.11523 5.10034C4.11212 5.01398 4.1209 4.9276 4.14133 4.84357C4.01389 5.23402 3.95939 5.64408 3.98049 6.05376C3.77869 5.77108 3.62065 5.46032 3.51158 5.1317C3.18649 5.69619 2.98196 6.36793 3.02593 7.08083C3.0299 7.14579 3.016 7.22867 2.9692 7.05283C2.81819 6.48433 2.73254 5.90085 2.71389 5.31342C2.68254 4.34876 2.82666 3.38636 3.1394 2.47191C3.80333 3.20191 4.57167 3.83232 5.42013 4.3432C5.64253 4.47872 5.775 4.74837 5.78465 5.03902L5.78351 5.03818ZM18.5961 7.4608C18.8012 6.71754 18.9044 5.95047 18.9028 5.18014C18.9028 3.22317 18.2566 1.42496 17.1724 0C15.8091 2.45623 13.2722 4.11415 10.3671 4.11415C7.462 4.11415 4.9254 2.45623 3.56207 0C2.47845 1.42496 1.83167 3.22317 1.83167 5.18014C1.8302 5.95049 1.93344 6.71755 2.13861 7.4608C1.01498 8.30894 0.221264 9.61686 0 11.1255C0.424821 10.9913 0.865606 10.9125 1.31113 10.8912C0.723463 11.8149 0.414044 12.8845 0.418985 13.9752C0.418985 15.4273 0.948032 16.7495 1.80614 17.7178C2.03336 17.2733 2.30052 16.8498 2.6044 16.4524C2.78808 17.6932 3.24681 18.8787 3.94787 19.9245C4.06202 20.1031 4.18657 20.275 4.3209 20.4394C4.56023 19.6596 4.97147 18.9418 5.52509 18.3374C5.2169 18.4072 4.90226 18.4456 4.58613 18.4519C4.13445 17.6091 3.89977 16.6695 3.90276 15.716C3.90214 15.1297 3.99 14.5466 4.16346 13.9858C3.47299 14.1418 2.82325 14.4387 2.25605 14.8575C2.21729 14.5827 2.19786 14.3055 2.19789 14.0281C2.19789 10.9573 4.04885 9.49197 6.20505 9.49197C10.4698 9.49197 9.10248 16.0601 8.44748 18.163C9.6814 17.6849 11.0528 17.6849 12.2867 18.163C11.6326 16.0598 10.2647 9.4917 14.5294 9.4917C16.6853 9.4917 18.5366 10.957 18.5366 14.0278C18.5366 14.3053 18.5172 14.5824 18.4784 14.8572C17.9112 14.4384 17.2615 14.1415 16.571 13.9855C16.7445 14.5463 16.8323 15.1294 16.8317 15.7157C16.8345 16.669 16.5997 17.6084 16.1481 18.4511C15.8319 18.4448 15.5173 18.4064 15.2091 18.3366C15.7627 18.9409 16.1739 19.6588 16.4133 20.4386C16.5474 20.2742 16.6719 20.1024 16.786 19.9239C17.4871 18.8782 17.946 17.6927 18.1298 16.4518C18.4337 16.8492 18.7008 17.2727 18.928 17.7172C19.7861 16.7489 20.3152 15.4267 20.3152 13.9746C20.32 12.8839 20.0106 11.8144 19.423 10.8906C19.8686 10.912 20.3094 10.9908 20.7342 11.125C20.5129 9.61574 19.7189 8.30838 18.5956 7.46024"
              fill="url(#paint1_linear_442_396)"
            />
            <path
              d="M6.91138 11.7678C6.91138 11.7678 6.98485 11.8264 7.06002 11.8882C6.91053 12.3242 6.61636 12.5603 6.18064 12.5603C5.59287 12.5603 5.27289 12.1123 5.34352 11.5242C5.34966 11.448 5.36755 11.3731 5.39657 11.3022C5.44054 11.2997 5.48479 11.2983 5.52905 11.2983C5.61892 11.2983 5.70872 11.3035 5.79797 11.314C5.80024 11.3193 5.80137 11.3226 5.80137 11.3226C5.54862 11.8359 6.02235 12.2117 6.02235 12.2117C6.02235 12.2117 6.23227 12.1666 6.49949 11.9876C6.65267 11.9011 6.706 11.6637 6.91081 11.7692L6.91138 11.7678ZM7.24186 11.7636C6.49353 11.0076 5.23403 10.8528 4.32003 11.3982L4.30188 11.4086C4.4331 11.8213 4.6753 12.191 5.00267 12.4785C5.33003 12.766 5.73029 12.9604 6.16078 13.041L6.15936 13.0461C6.85011 13.1432 7.49262 13.5641 7.86679 14.1101C8.10961 13.2928 7.86196 12.3559 7.24271 11.7631"
              fill="url(#paint2_linear_442_396)"
            />
            <path
              d="M13.8227 11.7678C13.8227 11.7678 13.7493 11.8264 13.6744 11.8882C13.8239 12.3242 14.118 12.5603 14.5538 12.5603C15.1412 12.5603 15.4615 12.1123 15.3909 11.5242C15.3847 11.448 15.3668 11.3731 15.3378 11.3022C15.2939 11.2997 15.2496 11.2983 15.2051 11.2983C15.1153 11.2983 15.0256 11.3035 14.9364 11.314L14.9327 11.3226C15.1858 11.8359 14.712 12.2117 14.712 12.2117C14.712 12.2117 14.5021 12.1666 14.2349 11.9876C14.0817 11.9011 14.0281 11.6637 13.8233 11.7692L13.8227 11.7678ZM13.4925 11.7636C14.2406 11.0076 15.5004 10.8528 16.4144 11.3982L16.4322 11.4086C16.3011 11.8213 16.059 12.1911 15.7317 12.4786C15.4043 12.766 15.0041 12.9605 14.5736 13.041V13.0461C13.8829 13.1432 13.2403 13.5641 12.8665 14.1101C12.6236 13.2928 12.8713 12.3559 13.4905 11.7631"
              fill="url(#paint3_linear_442_396)"
            />
            <path
              d="M12.0371 20.0015C12.0371 19.2914 11.2896 18.9717 10.3671 18.9717C9.44462 18.9717 8.69714 19.2914 8.69714 20.0015C8.69739 20.0465 8.70052 20.0914 8.7065 20.136C8.79161 20.752 9.47753 21.0454 10.3671 21.4677C11.2567 21.0454 11.9421 20.752 12.028 20.136C12.0339 20.0914 12.037 20.0465 12.0371 20.0015Z"
              fill="url(#paint4_linear_442_396)"
            />
            <path
              d="M6.29097 19.9558C6.2701 20.1033 6.25967 20.2521 6.25977 20.401C6.25977 22.3891 8.09853 24 10.3671 24C12.6356 24 14.4746 22.3885 14.4746 20.401C14.4746 20.2521 14.4642 20.1033 14.4434 19.9558C14.0389 21.5902 13.0024 22.7531 11.7874 22.7531C11.27 22.7531 10.7849 22.542 10.3671 22.1737C9.94949 22.542 9.46441 22.7531 8.94699 22.7531C7.73203 22.7531 6.69549 21.5902 6.29097 19.9558Z"
              fill="url(#paint5_linear_442_396)"
            />
            <path
              d="M18.0214 5.31398C18.0028 5.90141 17.9171 6.48489 17.7661 7.05339C17.7193 7.22867 17.7054 7.14579 17.7094 7.08139C17.7533 6.36849 17.5485 5.69675 17.2237 5.13226C17.115 5.46088 16.9573 5.77165 16.7557 6.05432C16.7767 5.64466 16.7223 5.23463 16.5951 4.84413C16.6156 4.92815 16.6243 5.01454 16.6209 5.1009C16.605 5.58587 16.2181 5.96556 15.7569 5.94848C15.2956 5.9314 14.9342 5.52455 14.951 5.03957C14.9606 4.74893 15.0928 4.47956 15.3158 4.34376C16.1639 3.83254 16.9318 3.20184 17.5953 2.47163C17.9082 3.38605 18.0523 4.34847 18.0209 5.31314L18.0214 5.31398ZM5.78351 5.03818C5.79968 5.52315 5.43885 5.93028 4.97788 5.94708C4.51691 5.96388 4.13027 5.58531 4.11523 5.10034C4.11212 5.01398 4.1209 4.9276 4.14133 4.84357C4.01389 5.23402 3.95939 5.64408 3.98049 6.05376C3.77869 5.77108 3.62065 5.46032 3.51158 5.1317C3.18649 5.69619 2.98196 6.36793 3.02593 7.08083C3.0299 7.14579 3.016 7.22867 2.9692 7.05283C2.81819 6.48433 2.73254 5.90085 2.71389 5.31342C2.68254 4.34876 2.82666 3.38636 3.1394 2.47191C3.80333 3.20191 4.57167 3.83232 5.42013 4.3432C5.64253 4.47872 5.775 4.74837 5.78465 5.03902L5.78351 5.03818ZM18.5961 7.4608C18.8012 6.71754 18.9044 5.95047 18.9028 5.18014C18.9028 3.22317 18.2566 1.42496 17.1724 0C15.8091 2.45623 13.2722 4.11415 10.3671 4.11415C7.462 4.11415 4.9254 2.45623 3.56207 0C2.47845 1.42496 1.83167 3.22317 1.83167 5.18014C1.8302 5.95049 1.93344 6.71755 2.13861 7.4608C1.01498 8.30894 0.221264 9.61686 0 11.1255C0.424821 10.9913 0.865606 10.9125 1.31113 10.8912C0.723463 11.8149 0.414044 12.8845 0.418985 13.9752C0.418985 15.4273 0.948032 16.7495 1.80614 17.7178C2.03336 17.2733 2.30052 16.8498 2.6044 16.4524C2.78808 17.6932 3.24681 18.8787 3.94787 19.9245C4.06202 20.1031 4.18657 20.275 4.3209 20.4394C4.56023 19.6596 4.97147 18.9418 5.52509 18.3374C5.2169 18.4072 4.90226 18.4456 4.58613 18.4519C4.13445 17.6091 3.89977 16.6695 3.90276 15.716C3.90214 15.1297 3.99 14.5466 4.16346 13.9858C3.47299 14.1418 2.82325 14.4387 2.25605 14.8575C2.21729 14.5827 2.19786 14.3055 2.19789 14.0281C2.19789 10.9573 4.04885 9.49197 6.20505 9.49197C10.4698 9.49197 9.10248 16.0601 8.44748 18.163C9.6814 17.6849 11.0528 17.6849 12.2867 18.163C11.6326 16.0598 10.2647 9.4917 14.5294 9.4917C16.6853 9.4917 18.5366 10.957 18.5366 14.0278C18.5366 14.3053 18.5172 14.5824 18.4784 14.8572C17.9112 14.4384 17.2615 14.1415 16.571 13.9855C16.7445 14.5463 16.8323 15.1294 16.8317 15.7157C16.8345 16.669 16.5997 17.6084 16.1481 18.4511C15.8319 18.4448 15.5173 18.4064 15.2091 18.3366C15.7627 18.9409 16.1739 19.6588 16.4133 20.4386C16.5474 20.2742 16.6719 20.1024 16.786 19.9239C17.4871 18.8782 17.946 17.6927 18.1298 16.4518C18.4337 16.8492 18.7008 17.2727 18.928 17.7172C19.7861 16.7489 20.3152 15.4267 20.3152 13.9746C20.32 12.8839 20.0106 11.8144 19.423 10.8906C19.8686 10.912 20.3094 10.9908 20.7342 11.125C20.5129 9.61574 19.7189 8.30838 18.5956 7.46024"
              fill="url(#paint6_linear_442_396)"
            />
            <path
              d="M6.91138 11.7678C6.91138 11.7678 6.98485 11.8264 7.06002 11.8882C6.91053 12.3242 6.61636 12.5603 6.18064 12.5603C5.59287 12.5603 5.27289 12.1123 5.34352 11.5242C5.34966 11.448 5.36755 11.3731 5.39657 11.3022C5.44054 11.2997 5.48479 11.2983 5.52905 11.2983C5.61892 11.2983 5.70872 11.3035 5.79797 11.314C5.80024 11.3193 5.80137 11.3226 5.80137 11.3226C5.54862 11.8359 6.02235 12.2117 6.02235 12.2117C6.02235 12.2117 6.23227 12.1666 6.49949 11.9876C6.65267 11.9011 6.706 11.6637 6.91081 11.7692L6.91138 11.7678ZM7.24186 11.7636C6.49353 11.0076 5.23403 10.8528 4.32003 11.3982L4.30188 11.4086C4.4331 11.8213 4.6753 12.191 5.00267 12.4785C5.33003 12.766 5.73029 12.9604 6.16078 13.041L6.15936 13.0461C6.85011 13.1432 7.49262 13.5641 7.86679 14.1101C8.10961 13.2928 7.86196 12.3559 7.24271 11.7631"
              fill="url(#paint7_linear_442_396)"
            />
            <path
              d="M13.8227 11.7678C13.8227 11.7678 13.7493 11.8264 13.6744 11.8882C13.8239 12.3242 14.118 12.5603 14.5538 12.5603C15.1412 12.5603 15.4615 12.1123 15.3909 11.5242C15.3847 11.448 15.3668 11.3731 15.3378 11.3022C15.2939 11.2997 15.2496 11.2983 15.2051 11.2983C15.1153 11.2983 15.0256 11.3035 14.9364 11.314L14.9327 11.3226C15.1858 11.8359 14.712 12.2117 14.712 12.2117C14.712 12.2117 14.5021 12.1666 14.2349 11.9876C14.0817 11.9011 14.0281 11.6637 13.8233 11.7692L13.8227 11.7678ZM13.4925 11.7636C14.2406 11.0076 15.5004 10.8528 16.4144 11.3982L16.4322 11.4086C16.3011 11.8213 16.059 12.1911 15.7317 12.4786C15.4043 12.766 15.0041 12.9605 14.5736 13.041V13.0461C13.8829 13.1432 13.2403 13.5641 12.8665 14.1101C12.6236 13.2928 12.8713 12.3559 13.4905 11.7631"
              fill="url(#paint8_linear_442_396)"
            />
            <path
              d="M12.0371 20.0015C12.0371 19.2914 11.2896 18.9717 10.3671 18.9717C9.44462 18.9717 8.69714 19.2914 8.69714 20.0015C8.69739 20.0465 8.70052 20.0914 8.7065 20.136C8.79161 20.752 9.47753 21.0454 10.3671 21.4677C11.2567 21.0454 11.9421 20.752 12.028 20.136C12.0339 20.0914 12.037 20.0465 12.0371 20.0015Z"
              fill="url(#paint9_linear_442_396)"
            />
            <path
              d="M126 18.1976L120.51 12.1682L125.071 6.5953H121.895L117.969 11.4489V6.5953H115.395V18.2002H117.969V13.0036L122.677 18.2002L126 18.1976ZM110.86 17.2445C111.899 16.5224 112.638 15.4439 112.938 14.2127H110.12C109.88 14.7354 109.48 15.1677 108.979 15.4466C108.473 15.7348 107.9 15.8843 107.318 15.8801C106.276 15.8801 105.437 15.5476 104.801 14.8825C104.164 14.2175 103.847 13.3898 103.848 12.3994C103.848 11.4079 104.165 10.5799 104.801 9.91549C105.436 9.25106 106.275 8.91884 107.318 8.91884C107.899 8.91489 108.472 9.06405 108.979 9.35146C109.48 9.63082 109.88 10.063 110.12 10.5853H112.938C112.637 9.35445 111.899 8.27633 110.86 7.55441C109.833 6.80028 108.591 6.39654 107.318 6.40245C105.569 6.40245 104.119 6.97986 102.968 8.13466C101.818 9.28946 101.242 10.7116 101.241 12.4012C101.241 14.0896 101.817 15.5117 102.968 16.6677C104.119 17.8236 105.569 18.401 107.318 18.3999C108.591 18.4048 109.833 17.9998 110.86 17.2445ZM95.669 13.49H92.753L94.2195 10.0094L95.669 13.49ZM90.7983 18.1959L91.825 15.7444H96.614L97.6399 18.1959H100.344L95.3925 6.59104H93.0465L88.0941 18.1959H90.7983ZM84.6397 11.6434C84.4884 11.7894 84.3096 11.9036 84.1137 11.9794C83.9178 12.0551 83.7088 12.0909 83.499 12.0846H82.1924V9.04513H83.4956C83.9629 9.04513 84.3456 9.18933 84.6439 9.47775C84.7866 9.61967 84.8997 9.78864 84.9766 9.97481C85.0536 10.161 85.0928 10.3607 85.0921 10.5622C85.0914 10.7637 85.0507 10.9631 84.9725 11.1487C84.8942 11.3344 84.7799 11.5025 84.6363 11.6434H84.6397ZM83.5305 6.5936H79.5997V18.1985H82.189V14.5216H83.5254C84.6873 14.5216 85.6565 14.143 86.4328 13.3859C87.2092 12.6287 87.5973 11.6901 87.5973 10.57C87.5973 9.4476 87.2092 8.50528 86.4328 7.743C85.6565 6.98071 84.6873 6.59929 83.5254 6.59872L83.5305 6.5936ZM72.4629 18.2036V13.6606H76.0058V11.1767H72.4663V9.08523H76.995V6.5953H69.8761V18.2002L72.4629 18.2036ZM67.4118 18.2036V15.7196H62.6296V6.5953H60.036V18.2002L67.4118 18.2036ZM57.3931 12.4012C57.3931 10.756 56.8092 9.34521 55.6416 8.16879C54.474 6.99238 53.065 6.40416 51.4148 6.40416C49.764 6.40416 48.3548 6.98953 47.1872 8.16026C46.0195 9.33099 45.436 10.7446 45.4366 12.4012C45.4366 14.0566 46.0201 15.4699 47.1872 16.6412C48.3542 17.8125 49.7634 18.3982 51.4148 18.3982C53.065 18.3982 54.474 17.8099 55.6416 16.6335C56.8092 15.4571 57.3931 14.0463 57.3931 12.4012ZM48.0429 12.4012C48.0367 11.9474 48.1206 11.4969 48.2897 11.0761C48.4588 10.6552 48.7098 10.2722 49.0279 9.94963C49.3344 9.62478 49.7037 9.36603 50.1132 9.1892C50.5227 9.01237 50.9639 8.92117 51.4097 8.92117C51.8555 8.92117 52.2967 9.01237 52.7062 9.1892C53.1158 9.36603 53.485 9.62478 53.7915 9.94963C54.4189 10.6105 54.7689 11.4881 54.7689 12.4007C54.7689 13.3133 54.4189 14.191 53.7915 14.8518C53.4852 15.177 53.116 15.4361 52.7065 15.6131C52.2969 15.7901 51.8557 15.8815 51.4097 15.8815C50.9637 15.8815 50.5225 15.7901 50.1129 15.6131C49.7034 15.4361 49.3342 15.177 49.0279 14.8518C48.7096 14.5295 48.4585 14.1468 48.2894 13.726C48.1203 13.3052 48.0365 12.8548 48.0429 12.4012ZM41.2166 18.2036L43.9046 6.59872H41.1375L39.5578 13.9525L36.3025 6.3999L33.0607 13.949L31.4802 6.5953H28.7089L31.3799 18.2002H33.8399L36.3025 12.5274L38.7616 18.1976L41.2166 18.2036Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="paint0_linear_442_396"
                x1="5.74634"
                y1="19.9558"
                x2="5.86328"
                y2="24.2353"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#F2674A" />
                <stop offset="1" stop-color="#FCB118" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_442_396"
                x1="-1.29589"
                y1="-3.70057e-09"
                x2="-0.114988"
                y2="21.5803"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#F2674A" />
                <stop offset="1" stop-color="#FCB118" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_442_396"
                x1="4.07332"
                y1="11.0735"
                x2="4.22123"
                y2="14.2824"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#F2674A" />
                <stop offset="1" stop-color="#FCB118" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_442_396"
                x1="12.5458"
                y1="11.0735"
                x2="12.6937"
                y2="14.2824"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#F2674A" />
                <stop offset="1" stop-color="#FCB118" />
              </linearGradient>
              <linearGradient
                id="paint4_linear_442_396"
                x1="8.4884"
                y1="18.9717"
                x2="8.59786"
                y2="21.6103"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#F2674A" />
                <stop offset="1" stop-color="#FCB118" />
              </linearGradient>
              <linearGradient
                id="paint5_linear_442_396"
                x1="5.74634"
                y1="19.9558"
                x2="5.86328"
                y2="24.2353"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#F2674A" />
                <stop offset="1" stop-color="#FCB118" />
              </linearGradient>
              <linearGradient
                id="paint6_linear_442_396"
                x1="-1.29589"
                y1="-3.70057e-09"
                x2="-0.114988"
                y2="21.5803"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#F2674A" />
                <stop offset="1" stop-color="#FCB118" />
              </linearGradient>
              <linearGradient
                id="paint7_linear_442_396"
                x1="4.07332"
                y1="11.0735"
                x2="4.22123"
                y2="14.2824"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#F2674A" />
                <stop offset="1" stop-color="#FCB118" />
              </linearGradient>
              <linearGradient
                id="paint8_linear_442_396"
                x1="12.5458"
                y1="11.0735"
                x2="12.6937"
                y2="14.2824"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#F2674A" />
                <stop offset="1" stop-color="#FCB118" />
              </linearGradient>
              <linearGradient
                id="paint9_linear_442_396"
                x1="8.4884"
                y1="18.9717"
                x2="8.59786"
                y2="21.6103"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#F2674A" />
                <stop offset="1" stop-color="#FCB118" />
              </linearGradient>
            </defs>
          </svg>
        </Link>
        <Box display='flex' position='relative' width={{ xs: '50%', lg: '62%', xl: '66%' }} justifyContent={{ xs: 'space-between', xl: 'space-around' }}>
          <TextField
            className="border-0 text-secondary"
            id="outlined"
            placeholder="Search Stock/ETF/Crypto"

            variant="outlined"
            value={search}
            onChange={(e) => {
              setsearch(e.target.value); console.log(e.target.value); console.log(search);
            }}

            slotProps={{
              input: {
                startAdornment: (
                  <svg
                    style={{ marginRight: "10px" }}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.5 21C6.25329 21 2 16.7467 2 11.5C2 6.25329 6.25329 2 11.5 2C16.7467 2 21 6.25329 21 11.5C21 16.7467 16.7467 21 11.5 21Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M22 22L20 20"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ),
              },
            }}
            sx={{
              // width:{{xs:'25%', lg:'30%'}},
              mt: '10px',
              width: { xs: '27%', lg: '32%', xl: '35%' },
              "& fieldset": {
                border: "1px solid",
                borderColor: "rgba(255, 255, 255, 0.1)", // Outline color
                borderRadius: "15px", // Adjust the outline's border radius
              },
              "& .MuiOutlinedInput-root": {
                borderRadius: "5px !important",
                borderColor: "rgba(255, 255, 255, 0.1) !important",
                height: "50px",
                maxWidth: "100%",
              },
            }}
          />
          {isVisible && search.length > 0 && searchResults.length > 0 && (
            <Box
              maxHeight='300px'
              ref={dropdownRef}
              padding='20px'
              sx={{
                overflow: 'auto',
                borderRadius: '20px',
                boxShadow: '0px 10px 20px #FFFFFF1A',
                left: '10px',
                top: '100%',
                zIndex: '999999',
                width: '650px',
                position: 'absolute',
                bgcolor: 'black'
              }}
            >
              {searchResults.map((rawStock) => {
                const stock = normalizeStockData(rawStock);
                const displayText = stock.type === "crypto" && !stock.displayName ? stock.symbol : stock.displayName;

                return (
                  <Box
                    key={stock.id}
                    mb="20px"
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    padding="8px 12px"
                    borderRadius="14px"
                    className="search-hover"
                    sx={{
                      background: stock.type === "crypto" ? "linear-gradient(90deg, #1A1A1A 60%, #F2674A1A 100%)" : "linear-gradient(90deg, #1A1A1A 60%, #DFDD4E1A 100%)",
                      boxShadow: stock.type === "crypto" ? "0 2px 8px #F2674A30" : "0 2px 8px #DFDD4E30",
                      transition: "background 0.2s",
                    }}
                    onClick={() => {
                      setIsVisible(false);
                      setsearch('');

                      if (stock.type === "crypto") {
                        navigation("/crypto-detail", {
                          state: { externalID: stock.cmc_id },
                        });
                      } else {
                        navigation("/stockdetail", {
                          state: {
                            symbol: stock.symbol,
                            icon: stock.logo,
                            title: stock.displayName,
                          },
                        });
                      }
                    }}
                  >
                    {/* Left section with logo + name */}
                    <Box display="flex" gap="10px" alignItems="center" minWidth="0" maxWidth="220px">
                      <Avatar
                        src={stock.logo}
                        alt={displayText}
                        sx={{
                          border: "1px solid white",
                          backgroundColor: "white",
                          objectFit: "contain",
                          width: 36,
                          height: 36,
                        }}
                        className="icon"
                      />
                      <Typography className="text-white" fontWeight="bold"
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: stock.type === "crypto" ? "120px" : "180px",
                          fontSize: stock.type === "crypto" ? "1.05rem" : "1.15rem",
                        }}
                      >
                        {displayText}
                      </Typography>
                    </Box>

                    {/* Symbol + Type */}
                    <Box display="flex" alignItems="center" gap="8px">
                      <Typography className="text-white" fontWeight="bold" sx={{ fontSize: "1.05rem" }}>
                        {stock.symbol}
                      </Typography>

                    </Box>
                    {/* Price */}
                    <Typography className="text-white" fontWeight="bold" sx={{ minWidth: "70px", textAlign: "right" }}>
                      {formatter.display(stock.stockPrice)}
                    </Typography>

                    {/* Change */}
                    <Typography
                      fontWeight="bold"
                      sx={{
                        color: stock.change === 0 ? "#fff" : stock.change > 0 ? "#4AF267" : "#F2674A",
                        minWidth: "60px",
                        textAlign: "right",
                        fontSize: "1.05rem",
                      }}
                    >
                      {formatPercentage(stock.change, { showSign: true })}
                    </Typography>
                    {/* <Button
                    onClick={() => {
                      setIsVisible(false); // Hide the dropdown
                      setsearch(''); // Clear the search
                      navigation("/stockdetail", {
                        state: {
                          symbol: stock.symbol,
                          icon: stock.branding?.logo_url ?? stock.branding?.icon_url,
                          title: stock.displayName,
                        },
                      });
                    }}
                    sx={{
                      padding: "2px 15px",
                      backgroundColor: '#FFFFFF1A',
                      borderRadius: '50px',
                      color: stock.type === 'ETF' ? '#DFDD4E' : '#F2674A'
                    }}
                  >
                    {stock.type}
                  </Button> */}
                    <Box
                      sx={{
                        padding: "2px 12px",
                        borderRadius: "16px",
                        background:
                          stock.type?.toUpperCase() === "CRYPTO"
                            ? "#F2674A"
                            : stock.type?.toUpperCase() === "ETF"
                              ? "#4EDF6D"
                              : "#DFDD4E",
                        color: "#000",
                        fontWeight: 700,
                        fontSize: "0.95rem",
                        letterSpacing: "1px",
                      }}
                    >
                      {stock.type?.toUpperCase() === "CRYPTO"
                        ? "CRYPTO"
                        : stock.type?.toUpperCase() === "ETF"
                          ? "ETF"
                          : "STOCK"}
                    </Box>
                    <IconButton onClick={(e) => { e.stopPropagation(); handleToggleWatchList(stock); }}>                      {stock?.isAddedToWatchList ? (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="24" height="24" rx="7.5" fill="#4A7AF2" fillOpacity="0.2" />
                        <path d="M13.8 7C15.6 7 16.5 7.8236 16.5 9.4708V15.2197C16.5 16.8424 15.231 17.4703 13.674 16.6222L12.486 15.9699C12.216 15.8231 11.784 15.8231 11.514 15.9699L10.326 16.6222C8.769 17.4703 7.5 16.8424 7.5 15.2197V9.4708C7.5 7.8236 8.4 7 10.2 7H13.8Z" fill="#4A7AF2" />
                      </svg>
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.375" y="0.375" width="23.25" height="23.25" rx="7.125" stroke="white" strokeWidth="0.75" />
                        <path d="M13.8 7C15.6 7 16.5 7.8236 16.5 9.4708V15.2197C16.5 16.8424 15.231 17.4703 13.674 16.6222L12.486 15.9699C12.216 15.8231 11.784 15.8231 11.514 15.9699L10.326 16.6222C8.769 17.4703 7.5 16.8424 7.5 15.2197V9.4708C7.5 7.8236 8.4 7 10.2 7H13.8Z" stroke="white" strokeOpacity="0.7" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    )}
                    </IconButton>
                  </Box>
                );
              })}
            </Box>
          )}

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width={{ xs: '70%', lg: '65%', xl: '60%' }}
            ml={1}
            sx={{
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              gap: { xs: 1, md: 2 },
              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': { display: 'none' },
              position: 'relative',
            }}
            ref={navScrollRef}
            onWheel={(e) => {
              const el = navScrollRef.current;
              if (!el) return;
              if (Math.abs(e.deltaY) > 0) {
                el.scrollBy({ left: e.deltaY, behavior: 'smooth' });
              }
            }}

          >
            {hasOverflow && (
              <IconButton
                onClick={() => navScrollRef.current?.scrollBy({ left: -220, behavior: 'smooth' })}
                onMouseEnter={() => smoothScrollToEdge('left')}
                sx={{
                  position: 'sticky',
                  left: 8,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: 24,
                  height: 24,
                  display: { xs: 'none', md: 'flex' },
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'linear-gradient(135deg, #F2674A 0%, #4A7AF2 100%)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  borderRadius: '50%',
                  color: '#fff',
                  boxShadow: '0 6px 18px rgba(74,122,242,0.35), 0 2px 8px rgba(0,0,0,0.4)',
                  zIndex: 2,
                  '&:hover': { boxShadow: '0 8px 22px rgba(74,122,242,0.45), 0 3px 10px rgba(0,0,0,0.5)', transform: 'translateY(-50%) scale(1.05)' },
                  opacity: canScrollLeft ? 1 : 0.25,
                  pointerEvents: canScrollLeft ? 'auto' : 'none',
                }}
              >
                <ArrowBackIosNewIcon sx={{ fontSize: 11, ml: '1px' }} />
              </IconButton>
            )}
            <NavLink
              className={({ isActive }) => (isActive ? "focus focus2" : "focus2")}

              to="/dashboard"
              style={({ isActive }) => ({
                color: isActive ? "#f2674a" : "",
                // borderBottom: isActive ? "2px solid #f2674a " : "",
                textDecoration: "none",
                height: '70px',
                display: 'flex',
                alignItems: 'center',
                flex: '0 0 auto',


              })}
            >
              Dashboard
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "focus focus2" : "focus2")}

              to="/wachlist"
              style={({ isActive }) => ({
                color: isActive ? "#f2674a" : "",
                // borderBottom: isActive ? "2px solid #f2674a " : "",
                textDecoration: "none",
                height: '70px',
                display: 'flex',
                alignItems: 'center',
                flex: '0 0 auto',


              })}
            >
              Watchlist
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "focus focus2" : "focus2")}
              to="/aianalysis"
              style={({ isActive }) => ({
                color: isActive ? "#f2674a" : "",
                textDecoration: "none",
                height: '70px',
                display: 'flex',
                alignItems: 'center',
                flex: '0 0 auto',
              })}
            >
              Mr. Wolf
            </NavLink>
            {/* <Box
              className={isActivebtn ? "focus focus2 " : "focus2"}
              sx={{ height: '70px', alignItems: 'center', display: 'flex' }}
            >
              <Box className="gradient-border">
                <NavLink
                  to="/askmrwolf"
                  className={({ isActive }) => {
                    setIsActivebtn(isActive); // Update state when the link becomes active
                    return isActive ? "active-link" : "";
                  }}
                  style={({ isActive }) => ({
                    color: isActive ? "#f2674a" : "",
                    textDecoration: "none",
                    backgroundColor: "#141414",
                  })}
                >
                  <Typography className="gradiant-text">Ask Mr. Wolf</Typography>
                </NavLink>
              </Box>
            </Box> */}
            {/* <Box
              className={isActivebtn ? "focus focus2 " : "focus2"}
              sx={{ height: '70px', alignItems: 'center', display: { xs: 'none', md: 'flex' } }}
            >
              <Box className="gradient-border">
                <NavLink
                  to="/aianalysis"
                  className={({ isActive }) => {
                    setIsActivebtn(isActive); // Update state when the link becomes active
                    return isActive ? "active-link" : "";
                  }}
                  style={({ isActive }) => ({
                    color: isActive ? "#f2674a" : "",
                    textDecoration: "none",
                    backgroundColor: "#141414",
                    flex: '0 0 auto',
                  })}
                >
                  <Typography className="gradiant-text">Mr. Wolf</Typography>
                </NavLink>
              </Box>
            </Box> */}
            <NavLink
              to={boosterLoanPath}
              className={({ isActive }) => (isActive ? "focus focus2" : "focus2")}
              style={({ isActive }) => ({
                color: isActive ? "#f2674a" : "",
                textDecoration: "none",
                height: '70px',
                display: 'flex',
                alignItems: 'center',
                flex: '0 0 auto',
              })}
            >

              Booster Loan

            </NavLink>
            {isTradingAccountComplete ?
              <NavLink
                to="/portfolio"
                className={({ isActive }) => (isActive ? "focus focus2" : "focus2")}

                style={({ isActive }) => ({
                  color: isActive ? "#f2674a" : "",
                  textDecoration: "none",
                  height: '70px',
                  display: 'flex',
                  alignItems: 'center',
                  flex: '0 0 auto',
                })}
              >
                Portfolio
              </NavLink>
              :
              // <NavLink
              //   to="/discovery"
              //   className={({ isActive }) => (isActive ? "focus focus2" : "focus2")}

              //   style={({ isActive }) => ({
              //     color: isActive ? "#f2674a" : "",
              //     textDecoration: "none",
              //     height: '70px',
              //     display: 'flex',
              //     alignItems: 'center',
              //     flex: '0 0 auto',
              //   })}
              // >
              //   Discovery
              // </NavLink>
              null
            }

            <NavLink
              to="/marketsignals"
              className={({ isActive }) => (isActive ? "focus focus2" : "focus2")}

              state={{ isHeader: true }}
              style={({ isActive }) => ({
                color: isActive ? "#f2674a" : "",
                textDecoration: "none",
                height: '70px',
                display: 'flex',
                alignItems: 'center',
                flex: '0 0 auto',
              })}
            >
              Market Signals
            </NavLink>

            <IconButton
              onClick={handleMoreOpen}
              sx={{ display: { xs: 'flex', md: 'none' }, height: '70px', alignItems: 'center' }}
            >
              <MoreHorizIcon className="text-white" />
            </IconButton>
            <Menu
              anchorEl={moreAnchorEl}
              open={isMoreOpen}
              onClose={handleMoreClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              PaperProps={{ sx: { bgcolor: '#141414', color: 'white', borderRadius: '12px' } }}
            >
              <MenuItem onClick={() => { handleMoreClose(); navigate('/aianalysis'); }}>Mr. Wolf</MenuItem>
              <MenuItem onClick={() => { handleMoreClose(); navigate(boosterLoanPath); }}>Booster Loan</MenuItem>
              {isTradingAccountComplete ? (
                <MenuItem onClick={() => { handleMoreClose(); navigate('/portfolio'); }}>Portfolio</MenuItem>
              ) : (
                // <MenuItem onClick={() => { handleMoreClose(); navigate('/discovery'); }}>Discovery</MenuItem>
                null
              )}
              <MenuItem onClick={() => { handleMoreClose(); navigate('/marketsignals', { state: { isHeader: true } }); }}>Market Signals</MenuItem>
            </Menu>
            {hasOverflow && (
              <IconButton
                onClick={() => navScrollRef.current?.scrollBy({ left: 220, behavior: 'smooth' })}
                onMouseEnter={() => smoothScrollToEdge('right')}
                sx={{
                  position: 'sticky',
                  right: 8,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: 24,
                  height: 24,
                  display: { xs: 'none', md: 'flex' },
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'linear-gradient(135deg, #F2674A 0%, #4A7AF2 100%)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  borderRadius: '50%',
                  color: '#fff',
                  boxShadow: '0 6px 18px rgba(74,122,242,0.35), 0 2px 8px rgba(0,0,0,0.4)',
                  zIndex: 2,
                  '&:hover': { boxShadow: '0 8px 22px rgba(74,122,242,0.45), 0 3px 10px rgba(0,0,0,0.5)', transform: 'translateY(-50%) scale(1.05)' },
                  opacity: canScrollRight ? 1 : 0.25,
                  pointerEvents: canScrollRight ? 'auto' : 'none',
                }}
              >
                <ArrowForwardIosIcon sx={{ fontSize: 11, mr: '1px' }} />
              </IconButton>
            )}
          </Box>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <LoanEligibleToggle />
          {/* <Typography
            className="text-white"
            sx={{
              fontSize: '0.875rem',
              whiteSpace: 'nowrap',
              display: { xs: 'none', md: 'block' }
            }}
          >
            Loan Eligible
          </Typography> */}
        </Box>
        <Box display="flex" width={{ xs: '22%', xl: '20%' }} alignItems='center' justifyContent="space-between">
          <IconButton>
            <NavLink
              className={({ isActive }) => (isActive ? "focus focus2" : "focus2")}

              to="/moreopt"
              style={({ isActive }) => ({
                textDecoration: "none",
              })}
            >
              {({ isActive }) => (
                <GridViewOutlinedIcon
                  className="focus2"
                  style={{
                    color: isActive ? "#f2674a" : "", // Change the icon color dynamically

                    height: '70px',
                    display: 'flex',
                    alignItems: 'center',
                  }}

                />
              )}
            </NavLink>
          </IconButton>
          <NotificationBell />
          {/* <Box display="flex" ml={2} alignItems='center' gap='10px'> */}
          {/* <Avatar
              alt="Remy Sharp"

              // src={user ? user.profile_pic : "/static/images/avatar/1.jpg"}
              src={
                user && user.profile_pic
                  ? `${user.profile_pic}?t=${new Date().getTime()}`
                  : '/static/images/avatar/1.jpg'
              }
              sx={{ width: 40, height: 40 }}
            /> */}

          {/* <Button
              id="basic-button"
              // sx={{ width: "150px" }}
              sx={{ marginLeft: '10px', padding:'0px' }}
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            > */}
          <NavLink
            to="/myprofile"
            className={({ isActive }) => (isActive ? "focus focus2" : "focus2")}

            style={({ isActive }) => ({
              color: isActive ? "#f2674a" : "",
              textDecoration: "none",
              height: '70px',
              display: 'flex',
              textTransform: 'none',
              alignItems: 'center',
              gap: '10px'
            })}>
            <Avatar
              alt="Remy Sharp"

              // src={user ? user.profile_pic : "/static/images/avatar/1.jpg"}
              src={
                user && user.profile_pic
                  ? `${user.profile_pic}?t=${new Date().getTime()}`
                  : '/static/images/avatar/1.jpg'
              }
              sx={{ width: 40, height: 40 }}
            />
            {fullName}
            <ArrowDropDownIcon className="text-white"></ArrowDropDownIcon>
          </NavLink>
          {/* </Button> */}
          {/* <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              sx={{
                bgcolor: 'transparent', padding: '0px !important',
                '.MuiMenu-list': {
                  padding: '0px',
                  // borderRadius:'50px !important'
                  borderRadius: '30px',
                }
              }}

              PaperProps={{
                sx: {
                  bgcolor: 'transparent',
                  borderRadius: '30px',
                }
              }}
            >
              <Box width='330px' display='flex' flexDirection='column' alignItems='center' borderRadius='20px' bgcolor='#141414'>
                <Box padding='30px 90px 0px 90px' display='flex' flexDirection='column' alignItems='center'><Avatar
                  alt="Remy Sharp"

                  src={user ? user.profile_pic : "/static/images/avatar/1.jpg"}
                  sx={{ width: 100, height: 100, mb: '20px' }}
                />
                  <Typography variant="h5" mb='10px' className="text-white" fontWeight='bold' textAlign='center'>{fullName}</Typography>
                  <Typography fontSize='18px' sx={{ textDecoration: 'none', mb: '20px' }} className="link">Superadmin</Typography>
                </Box>
                <Divider sx={{ border: '1px solid white', width: '100%', height: '1px' }}></Divider>
                <Button onClick={() => {
                  handleClose();
                  logOut();
                }} variant="text" sx={{ my: '20px', textTransform: 'none' }} className="text-white" startIcon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.90002 7.56023C9.21002 3.96023 11.06 2.49023 15.11 2.49023H15.24C19.71 2.49023 21.5 4.28023 21.5 8.75023V15.2702C21.5 19.7402 19.71 21.5302 15.24 21.5302H15.11C11.09 21.5302 9.24002 20.0802 8.91002 16.5402" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15 12H3.62" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.85 8.65039L2.5 12.0004L5.85 15.3504" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                }>Logout</Button>
              </Box> */}
          {/* <MenuItem
                onClick={() => {
                  handleClose();
                  navigation("/profile");
                }}
              >
                Profile
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleClose();
                  navigation("/myaccount");
                }}
              >
                My account
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleClose();
                  logOut();
                }}
              >
                Logout
              </MenuItem> */}
          {/* </Menu> */}

          {/* </Box> */}
        </Box>
      </Container>
    </>
  );
}

export default Header;